module.exports = __webpack_public_path__ + "img/13.1-gallery.d646d6fc.jpg";